<app-profile-slide-in-modal
  modalTitle="Notifications"
  [slideOpen]="true"
  (action)="closeModal()"
>
  <div class="page__container flex flex-col gap-6 px-1 pb-8">
    <!-- Opt-in prompt (only shown until the user has decided) -->
    @if (permission === 'default') {
      <div
        class="flex flex-col items-center gap-4 rounded-xl border border-gray-100 bg-mango-floralWhite p-6 text-center shadow-md"
      >
        <div
          class="flex h-14 w-14 items-center justify-center rounded-full bg-mango-crayolaGold"
        >
          <img
            src="/assets/images/svgs/notification-bell.svg"
            class="h-7 w-7"
            alt="Notifications"
          />
        </div>
        <div class="flex flex-col gap-1">
          <h3 class="text-base font-bold text-mango-grey">
            Turn on notifications
          </h3>
          <p class="text-sm text-gray-500">
            Get instant alerts about your investments, transactions and account
            activity.
          </p>
        </div>
        <button
          type="button"
          (click)="enableNotifications()"
          [disabled]="isEnabling"
          class="w-full rounded-lg bg-mango px-8 py-3 font-bold text-white transition hover:brightness-90 disabled:cursor-not-allowed disabled:opacity-60"
        >
          {{ isEnabling ? 'Enabling…' : 'Enable notifications' }}
        </button>
      </div>
    }

    @if (permission === 'denied') {
      <div
        class="rounded-xl border border-gray-100 bg-mango-floralWhite p-4 text-center shadow-sm"
      >
        <p class="text-sm text-gray-500">
          Notifications are blocked. To turn them on, enable notifications for
          this site in your browser settings.
        </p>
      </div>
    }

    <!-- Notification list -->
    @if (notifications().length > 0) {
      <div class="flex items-center justify-between">
        <span class="text-sm font-semibold text-mango-grey">Recent</span>
      </div>

      <ul class="flex flex-col gap-3">
        @for (item of notifications(); track item.id) {
          <li
            class="flex gap-3 rounded-xl border border-gray-100 bg-white p-3 shadow-sm"
          >
            @if (item.image_url) {
              <img
                [src]="item.image_url"
                alt=""
                class="h-12 w-12 flex-shrink-0 rounded-lg object-cover"
              />
            } @else {
              <div
                class="flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-lg bg-mango-papayaWhip"
              >
                <img
                  src="/assets/images/svgs/notification-bell.svg"
                  class="h-6 w-6"
                  alt=""
                />
              </div>
            }
            <div class="flex flex-1 flex-col gap-0.5">
              <div class="flex items-start justify-between gap-2">
                <h4 class="text-sm font-bold text-mango-grey">
                  {{ item.title }}
                </h4>
                <span class="flex-shrink-0 text-[11px] text-gray-400">
                  {{ timeAgo(item.sent_at ?? item.created_at) }}
                </span>
              </div>
              @if (item.message) {
                <p class="text-sm text-gray-500">{{ item.message }}</p>
              }

              @if (
                item.push_type === 'INTERACTIVE' &&
                (item.action1_url || item.action2_url)
              ) {
                <div class="mt-2 flex flex-wrap gap-2">
                  @if (item.action1_url) {
                    <button
                      type="button"
                      (click)="openAction(item.action1_url)"
                      class="rounded-lg bg-mango px-3 py-1.5 text-xs font-semibold text-white transition hover:brightness-90"
                    >
                      {{ item.action1_label || 'Open' }}
                    </button>
                  }
                  @if (item.action2_url) {
                    <button
                      type="button"
                      (click)="openAction(item.action2_url)"
                      class="rounded-lg border border-mango px-3 py-1.5 text-xs font-semibold text-mango transition hover:bg-mango-papayaWhip"
                    >
                      {{ item.action2_label || 'Open' }}
                    </button>
                  }
                </div>
              }
            </div>
          </li>
        }
      </ul>
    } @else {
      <!-- Empty state -->
      <div
        class="flex flex-col items-center justify-center gap-3 py-12 text-center"
      >
        <div
          class="flex h-16 w-16 items-center justify-center rounded-full bg-mango-papayaWhip"
        >
          <img
            src="/assets/images/svgs/notification-bell.svg"
            class="h-8 w-8"
            alt="Notifications"
          />
        </div>
        <h3 class="text-base font-bold text-mango-grey">No notifications yet</h3>
        <p class="max-w-xs text-sm text-gray-500">
          Your notifications will show up here as they arrive.
        </p>
      </div>
    }
  </div>
</app-profile-slide-in-modal>
